import React, { useEffect, useState } from 'react';
import '../../../index.scss';

// material
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
// ICON

import EditIcon from '@material-ui/icons/Edit';
import SearchIcon from '@material-ui/icons/Search';
import PrintIcon from '@material-ui/icons/Print';
import RefreshIcon from '@material-ui/icons/Refresh';
import GetAppIcon from '@material-ui/icons/GetApp';
// other
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import { GridColDef } from '@material-ui/data-grid';
import { setLoadingRedux } from 'reducers/shareData/action';
import { isType3, userTypeList } from 'main_consts';

import styled from 'styled-components';
import WarehouseModal from 'components/Modal/WareHouseModal';
import CheckBox from 'components/Material/Checkbox';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from 'reducers/shareData/selector';
import DateTimeSePickersTyping from 'components/DatePicker/DateTimeSePickersTyping';
import colW from 'components/NewTable/consts';
import { TableColumn } from 'components/NewTable/type';
import NewTable from 'components/NewTable/index';
import { IwarehouseList } from 'reducers/shareData/types';
import Header from 'components/Header';
import Radio from '../../../components/Radio';
import Select from '../../../components/Material/Select';
// component
import Menu from '../../../components/Menu';
import {
  formatDateTime,
  getDateDayPlus,
  getExpressName,
  getColWidthByField,
  getWarehouse,
  inputChange,
  radioChange,
  checkboxChange,
  selectChange,
  initWhrehhouse,
} from '../../../main_func';
import Input from '../../../components/Material/Input';
import { FormTitle, HVcGrid, VcEGrid, VcGrid } from '../../../components/Grid';
import {
  blobDownload,
  getExcel,
  getSearch,
  snackBarRsp,
} from '../../../main_api';

// import Table from '../../../components/Material/Table/index';

import { IrptNmNdLogList, Imaster } from './type';
import { Iobject, Ioption } from '../../../main_type';

/** 已申報未入倉清單 */
const RptNmNdLogQry = (): JSX.Element => {
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const dispatch = useDispatch();
  const [formError, setFormError] = useState(false);
  const { user, userType, locationCode } = useSelector(getUserInfoRedux);

  const { enqueueSnackbar } = useSnackbar();
  // function initWhrehhouse(
  //   UT: string,
  //   WHR: IwarehouseList[],
  //   LC: string
  // ): string {
  //   if (UT === userTypeList.type1[0]) {
  //     return LC;
  //   }
  //   if (UT === userTypeList.type2[0]) {
  //     return WHR.length > 0 ? WHR[0].locationCode : '';
  //   }
  //   return '';
  // }
  const masterDefaultValue: Imaster = {
    // 記帳代號
    chkCode1: (warehouseRedux[0] && warehouseRedux[0].chkCode1) || '',
    // 業者名稱
    expressCnName: '',
    // 主號
    mawbNo: '',
    // 櫃號
    containerNo: '',
    // 快遞倉站
    warehouse:
      userType === userTypeList.type1[0] || userType === userTypeList.type2[0]
        ? initWhrehhouse(userType, warehouseRedux, locationCode)
        : '',
    startDate: getDateDayPlus(),
    endDate: getDateDayPlus(),
    startTime: '0000',
    endTime: '2359',
    timeCheck: '1',
    endDateValid: true,
    endTimeValid: true,
    startDateValid: true,
    startTimeValid: true,
    // 濾除已進倉
    noGCIData: false,
    // 報表類型
    reason: 'RI',
    // 操作人員
    userid: '',

    pageSize: 100,
  };

  const apiName = 'rptNmNdLogQry';

  const [master, setMaster] = useState(masterDefaultValue);
  const [random, setRamdom] = useState(Math.random());

  const [expressName, setExpressName] = useState('');
  const [warehouseName, setWarehouseName] = useState('');
  const [openSearchTable, setOpenSearchTable] = useState(false);
  const [submitKey, setSubmitKey] = useState('search');
  const [rowData, setRowData] = useState<IrptNmNdLogList[]>([]);
  // const [colList, setColList] = useState<GridColDef[]>([]);
  const [listCol, setListCol] = useState<TableColumn[]>([]);
  const [randomValue, setRandomValue] = useState(Math.random());
  // const [resultOther, setResultOther] = useState<IresultOther>(
  //   {} as IresultOther
  // );
  const [reasonOptions, setReasonOptions] = useState<Ioption[]>([]);
  const [reasonMap, setReasonMap] = useState(new Map());

  useEffect(() => {
    const list: Ioption[] = [
      { value: 'RI', label: '申報件數不符' },
      { value: 'NM', label: '無艙單' },
      { value: 'ND', label: '有艙單無報單' },
      { value: 'NC', label: '櫃號不符' },
      { value: 'NB', label: '主號相同櫃號不符' },
    ];
    setReasonOptions(list);
    const tempReasonMap = new Map();
    tempReasonMap.set('RI', '申報件數不符');
    tempReasonMap.set('NM', '無艙單');
    tempReasonMap.set('ND', '有艙單無報單');
    tempReasonMap.set('NC', '櫃號不符');
    tempReasonMap.set('NB', '主號相同櫃號不符');
    setReasonMap(tempReasonMap);

    setMaster((prev) => ({ ...prev, warehouse: masterDefaultValue.warehouse }));
    if (
      userTypeList.type4.some((v) => v === userType) &&
      locationCode.trim().length === 0
    ) {
      setFormError(true);
    }
  }, [userType]);

  const DivStyle = styled.div`
    border: 3px outset #1c6ea4;
    margin-bottom: 1rem;
  `;

  const handleDownload = async (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getExcel(apiName, {
      expressid: master.chkCode1,
      warehouse: master.warehouse,
      reason: master.reason,
      userid: master.userid,
      mawbNo: master.mawbNo,
      containerNo: master.containerNo,
      // closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
      noGCIData: master.noGCIData,
    });
    // const startDate = formatDateTime(
    //   master.startDate,
    //   master.startTime,
    //   'MMdd'
    // );
    // const EndDate = formatDateTime(master.endDate, master.endTime, 'MMdd');

    blobDownload(
      result,
      enqueueSnackbar,
      `${
        master.reason.length > 0
          ? `${reasonMap.get(master.reason)}`
          : '報表類型'
      }.xlsx`
    );
    dispatch(setLoadingRedux(false));
  };

  const handleSearch = async (
    e?: React.FormEvent<HTMLFormElement>
  ): Promise<void> => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    dispatch(setLoadingRedux(true));
    const result = await getSearch(apiName, {
      expressid: master.chkCode1,
      warehouse: master.warehouse,
      reason: master.reason,
      userid: master.userid,
      mawbNo: master.mawbNo,
      containerNo: master.containerNo,
      // closeMark: master.closeMark,
      startDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.startDate, `${master.startTime}00`),
      endDate:
        master.timeCheck === '0'
          ? ''
          : formatDateTime(master.endDate, `${master.endTime}59`),
      noGCIData: master.noGCIData,
    });
    dispatch(setLoadingRedux(false));
    if (!snackBarRsp(enqueueSnackbar, result)) {
      return;
    }
    const rptNmNdLogList = result.data.data as IrptNmNdLogList[];

    if (rptNmNdLogList) {
      // console.log(rptNmNdLogList);

      if ((rptNmNdLogList || []).length > 0) {
        // setColList(
        //   getColWidthByField([
        //     { headerName: '項次', field: 'itemNo' },
        //     { headerName: '主號', field: 'mawbNo' },
        //     { headerName: '分號', field: 'hawbNo' },
        //     // { headerName: '報單號碼', field: 'declNo' },
        //     // { headerName: '申報', field: 'piece' },
        //     // { headerName: '進倉', field: 'gciPiece' },
        //     // { headerName: '出倉', field: 'gcoPiece' },
        //     // { headerName: '類別', field: 'appType' },
        //     // { headerName: '併袋號碼', field: 'expBagNo' },
        //     // { headerName: '註記', field: 'closeMark' },
        //     { headerName: '海掛', field: 'vesselRegNo' },
        //     { headerName: '艙號', field: 'manifNo' },
        //     // { headerName: '快遞倉站', field: 'warehouse' },
        //     // { headerName: '報關箱號', field: 'boxNo' },
        //     { headerName: '櫃號', field: 'containerNo' },
        //     { headerName: '記帳代號', field: 'expresssNameOrExpressId' },
        //   ])
        // );

        setListCol([
          { w: colW[1], t: '項次', f: 'itemNo' },
          { w: colW[8], t: '主號', f: 'mawbNo' },
          { w: colW[8], t: '刷碼袋號', f: 'hawbNo' },
          { w: colW[2], t: '作業人員ID', f: 'userid' },
          { w: colW[2], t: '記帳代號', f: 'expressid' },
          { w: colW[8], t: '刷碼時間', f: 'updtime' },
          { w: colW[8], t: '備註說明(櫃號)', f: 'containerNo' },
        ]);
        setRowData(rptNmNdLogList);
        setOpenSearchTable(true);
      } else {
        setOpenSearchTable(false);
      }
    } else {
      setOpenSearchTable(false);
    }
    setRandomValue(Math.random());
  };

  const handleSubmit = (e?: React.FormEvent<HTMLFormElement>) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    if (master.startDate.length === 0) {
      master.startDate = getDateDayPlus();
    }
    if (master.endDate.length === 0) {
      master.endDate = getDateDayPlus();
    }
    // if (master.mawbNo.length <= 0 && master.timeCheck === '0') {
    //   enqueueSnackbar('【主號】或【進倉日期區間】擇一必填。', {
    //     variant: 'warning',
    //   });
    //   return;
    // }
    if (
      (master.timeCheck === '1' &&
        (!master.endDateValid ||
          !master.endTimeValid ||
          !master.startDateValid ||
          !master.startTimeValid)) ||
      !(
        master.startDate &&
        master.endTime &&
        master.startDate &&
        master.startTime
      )
    ) {
      return;
    }
    switch (submitKey) {
      case 'search':
        handleSearch();
        break;
      case 'download':
        handleDownload();
        break;
      default:
        break;
    }
  };

  const updateData = async (updateObj: Iobject) => {
    setMaster({ ...master, ...updateObj });
    const key: string[] = Object.keys(updateObj);
    if (key[0] === 'chkCode1' || key[0] === 'warehouse') {
      const masterTemp = { ...master, ...updateObj };
      const { chkCode1, warehouse } = masterTemp;
      let warehouseResult = { text: '', error: false };
      let expressResult = { text: '', error: false };
      if (warehouse.length > 0) {
        warehouseResult = await getWarehouse(
          updateObj,
          master as unknown as Iobject
        );
        setWarehouseName(warehouseResult.text);
      } else {
        setWarehouseName('');
      }

      if (chkCode1.length > 0) {
        expressResult = await getExpressName(
          updateObj,
          master as unknown as Iobject
        );
        setExpressName(expressResult.text);
      } else {
        setExpressName('');
      }
      setFormError(warehouseResult.error || expressResult.error);
    }
  };

  const handleReset = async () => {
    setRamdom(Math.random());
    setMaster(masterDefaultValue);
    setExpressName(
      master.chkCode1.length > 1 ? warehouseRedux[0].expressName : ''
    );

    // console.log(master.chkCode1);
    // console.log(masterDefaultValue.chkCode1);
    // console.log(master.warehouse);
    // console.log(masterDefaultValue.warehouse);
    if (masterDefaultValue.warehouse.length === 0) {
      setWarehouseName('');
    }
    // console.log(warehouseRedux[0].chkCode1);
    // if (master.warehouse.length > 1) {
    //   updateData({
    //     warehouse: master.warehouse,
    //     chkCode1: masterDefaultValue.chkCode1,
    //   });
    // }
    setOpenSearchTable(false);
    setFormError(false);
    setRandomValue(Math.random());
  };
  const handleDownloadBarcode = () => {
    window.location.href = '/3of9BarcodeRegular.ttf';
  };

  return (
    <div id="page-area">
      <Header />
      <div className="breadcrumbs-area">
        {/* <Breadcrumbs>
          <Link
            className="icon-item"
            color="inherit"
            href="/"
            onClick={breadClick}
          >
            <HomeIcon className="icon" />
            首頁
          </Link>
          <Link
            color="inherit"
            href="/getting-started/installation/"
            onClick={breadClick}
          >
            進出倉作業查詢
          </Link>
          <Typography color="textPrimary">已申報未入倉清單</Typography>
        </Breadcrumbs> */}
      </div>
      <form onSubmit={handleSubmit} className="form-area">
        <div>
          <div className="title">
            <EditIcon /> 前倉作業異常報表查詢
          </div>
        </div>
        <div className="input-area">
          {/* <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              進出口別：
            </VcEGrid>
            <VcGrid item xs={12} sm={2}>
              <Radio
                className="input-radio"
                required
                name="declType"
                value={master.declType}
                onChange={radioChange(updateData)}
                options={[
                  { value: '1', label: '進口' },
                  { value: '2', label: '出口' },
                ]}
              />
            </VcGrid>
          </Grid> */}

          {/* 20210325 新增權限判斷 */}
          {userType && !isType3(userType) && (
            <Grid container>
              <VcEGrid item xs={12} sm={2} className="input-text">
                記帳代號：
              </VcEGrid>

              <VcGrid item xs={12} sm={3}>
                <Input
                  name="chkCode1"
                  disabled={userTypeList.type2.indexOf(userType) !== -1}
                  maxLength={4}
                  value={master.chkCode1}
                  onChange={(e) => {
                    inputChange(updateData)(e);
                  }}
                />
              </VcGrid>
              <VcGrid item xs={12} sm={3}>
                {expressName && (
                  <Alert
                    style={{
                      width: '100%',
                      color: 'red',
                      margin: '0 0.5rem',
                      fontSize: '1em',
                    }}
                    severity="info"
                    icon={false}
                  >
                    {expressName}
                  </Alert>
                )}
              </VcGrid>
            </Grid>
          )}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>
                {[...userTypeList.type2, ...userTypeList.type1].indexOf(
                  userType
                ) !== -1
                  ? '*'
                  : ''}
                快遞倉站：
              </FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm={3}>
              <WarehouseModal
                value={master.warehouse}
                updateData={updateData}
                setStatus={setWarehouseName}
              />
            </VcGrid>

            <VcGrid item xs={12} sm={3}>
              {warehouseName && (
                <Alert
                  severity="info"
                  style={{
                    width: '100%',
                    color: 'red',
                    margin: '0 0.5rem',
                    fontSize: '1em',
                  }}
                  icon={false}
                >
                  {warehouseName}
                </Alert>
              )}
            </VcGrid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*報表類型：</FormTitle>
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Select
                // placeholder="請先填入分號"
                value={master.reason}
                onChange={selectChange(updateData)}
                name="reason"
                options={reasonOptions}
                // disabled={options.length === 0}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              操作人員：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                // placeholder="主號或進倉日期區間擇一必填"
                maxLength={35}
                value={master.userid}
                name="userid"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              主號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                // placeholder="主號或進倉日期區間擇一必填"
                maxLength={35}
                value={master.mawbNo}
                name="mawbNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              櫃號：
            </VcEGrid>
            <Grid item xs={12} sm={3}>
              <Input
                maxLength={35}
                value={master.containerNo}
                name="containerNo"
                onChange={(e) => {
                  inputChange(updateData)(e);
                }}
              />
            </Grid>
          </Grid>
          {/* <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              作業註記：
            </VcEGrid>
            <VcGrid item xs={12} sm={10}>
              <Radio
                className="input-radio"
                required
                name="closeMark"
                value={master.closeMark}
                onChange={radioChange(updateData)}
                options={[
                  { value: 'A', label: '全選' },
                  { value: 'N', label: '無註記(非查扣、短卸)' },
                  { value: 'Z', label: '查扣' },
                  { value: 'L', label: '短卸' },
                ]}
              />
            </VcGrid>
          </Grid> */}

          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text">
              <FormTitle>*查詢日期區間：</FormTitle>
            </VcEGrid>
            <VcGrid item xs={12} sm style={{ maxWidth: 800 }}>
              <DateTimeSePickersTyping
                key={random}
                required={master.timeCheck === '1'}
                disabled={master.timeCheck === '0'}
                updateData={updateData}
                style={{ maxWidth: 800 }}
                names={[
                  ['startDate', 'startTime'],
                  ['endDate', 'endTime'],
                ]}
                data={master}
                setDayRange={7}
              />
            </VcGrid>
            {/* <VcGrid item xs={12} sm={2}>
              <CheckBox
                label="加入時間查詢"
                checked={master.timeCheck === '1'}
                name="timeCheck"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    startDate: masterDefaultValue.startDate,
                    startTime: masterDefaultValue.startTime,
                    endDate: masterDefaultValue.endDate,
                    endTime: masterDefaultValue.endTime,
                    ...checkboxChange()(['1', '0'])(e),
                  }));
                }}
              />
            </VcGrid> */}
          </Grid>
          <Grid container>
            <VcEGrid item xs={12} sm={2} className="input-text" />
            <Grid item xs={12} sm={3}>
              <CheckBox
                label="濾除已進倉"
                disabled={master.reason === 'RI'}
                checked={master.noGCIData === true}
                name="noGCIData"
                onChange={(e) => {
                  setMaster((prev) => ({
                    ...prev,
                    ...checkboxChange()([true, false])(e),
                  }));
                }}
              />
            </Grid>
          </Grid>
        </div>
        <Grid container className="button-area">
          <VcEGrid item xs={12} sm={2}>
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<SearchIcon />}
              onClick={() => setSubmitKey('search')}
            >
              查詢
            </Button>
          </VcEGrid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={formError}
              type="submit"
              variant="contained"
              color="default"
              startIcon={<PrintIcon />}
              onClick={() => setSubmitKey('download')}
            >
              下載Excel
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              disabled={
                userTypeList.type4.some((v) => v === userType) &&
                locationCode.trim().length === 0
              }
              variant="outlined"
              color="primary"
              startIcon={<RefreshIcon />}
              onClick={() => handleReset()}
            >
              重置
            </Button>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              variant="outlined"
              color="primary"
              startIcon={<GetAppIcon />}
              onClick={() => handleDownloadBarcode()}
            >
              下載BarCode字型
            </Button>
          </Grid>
        </Grid>
      </form>
      {openSearchTable && (
        <>
          <NewTable<IrptNmNdLogList>
            data={rowData}
            columns={listCol}
            pageSize={master.pageSize}
            pageSizeOptions={[100, 50, 10]}
          />
          {/* <Table
            key={randomValue}
            data={rowData as unknown as Iobject[]}
            columns={colList}
            rowsPerPageOptions={[100, 50, 10]}
            rootProps={{ style: { height: '400px' } }}
            pageSize={100}
          /> */}
        </>
      )}
    </div>
  );
};

export default RptNmNdLogQry;
